<div id="login-form"><font-awesome-icon icon="user-secret"></font-awesome-icon></div>